<template>
  <div class="main">
    <Header 
      :show="true"
      title="修改供应商信息"
      left="prepage" 
      right="" 
      :click-left="handleClickLeft" 
      :click-right="handleClickRight"
    />
    <div style="padding-bottom: 8vh;">
      <van-notice-bar
        left-icon="info-o"
        color="#ed6a0c" background="#FFFBE8" 
        text="注意：更新供应商信息不支持修改名称"
      />
      
      <van-form 
        ref="update"
        @submit="submit"
      >
        <van-field
        v-model.trim="listQuery.name"
        label="名称"
        placeholder="请输入供应商名称"
        required
        disabled
        :rules="[{ validator: validName, message: '' }]"
      />
      <van-field 
        name="checkboxGroup" 
        label="供应物料"
        required
      >
        <template #input>
          <van-checkbox-group v-model="listQuery.material" direction="horizontal">
            <van-checkbox 
              v-for="item in materialOptions"
              :key="item.id"
              :name="item.id" 
              shape="square"
            >
            {{ item.name }}
            </van-checkbox>
          </van-checkbox-group>
        </template>
      </van-field>
      <van-field
        v-model.trim="listQuery.address"
        label="地址"
        placeholder="请输入供应商地址"
        required
        :rules="[{ validator: validName, message: '' }]"
      />
      <van-field
        v-model.trim="listQuery.leader"
        label="负责人"
        placeholder="请输入供应商负责人"
        required
        :rules="[{ validator: validName, message: '' }]"
      />
      <van-field
        v-model.trim="listQuery.phone"
        label="手机号码"
        placeholder="请输入手机号码"
        required
        :rules="[{ validator: validName, message: '' }]"
      />
      <van-field
        v-model.trim="listQuery.email"
        label="电子邮箱"
        placeholder="请输入电子邮箱"
      />
      <van-field
        v-model.trim="listQuery.remark"
        rows="2"
        autosize
        label="说明"
        type="textarea"
        maxlength="100"
        placeholder="请输入供应商说明"
        show-word-limit
        />
        <div style="margin: .6rem 1rem;" v-if="checkPermission([183])">
          <van-button round block type="info" native-type="submit">
            确定
          </van-button>
        </div>
      </van-form>
    </div>
    <Footer value="service" />
  </div>
</template>

<script>
  import { Dialog } from 'vant'
  import { showPhoneAlarm } from '@/global/function.js'
  import checkPermission from '@/utils/permission'
  import Header from '@/views/components/header/index.vue'
  import Footer from '@/views/components/footer/index.vue'
  import { isUserName, isPassword, isChinese, isPhone, isEmail } from '@/utils/validate.js'
  import { getList as getMaterialList } from '@/api/material.js'
  import { updateOne } from '@/api/supplier.js'

  export default {
    name: "ServiceSystemSupplierUpdate",
    components: {
      Header,
      Footer
    },
    inject: ['reload'],
    data() {
      return {
        isLoading: false,
        loading: false,
        listQuery: {
          serial: '',
          name: '',
          material: [],
          address: '',
          leader: '',
          phone: '',
          email: '',
          remark: ''
        },
        materialOptions: []
      }
    },
    computed: {

    },
    watch: {
      
    },
    beforeCreate() {
      
    },
    created() {
      this.handleGetMaterialList()
    },
    beforeMount() {
      
    },
    mounted() {
      this.listQuery = this.$route.query
    },
    beforeUpdate() {
      
    },
    updated() {
      
    },
    beforeDestroy() {
      
    },
    destroyed() {
      
    },
    methods: {
      checkPermission,
      handleClickLeft() {
        this.$router.go(-1)
        // console.log('dashboard-left')
      },
      handleClickRight() {
        this.$refs.update.submit()
      },
      submit() {
        Dialog.confirm({
          title: '确认更新供应商？',
          message: '供应商名称：' + this.listQuery.name
        }).then(() => {
          this.loading = true
          const data = {
            id: this.listQuery.serial,
            name: this.listQuery.name,
            materialIds: this.listQuery.material,
            address: this.listQuery.address,
            leader: this.listQuery.leader,
            phone: this.listQuery.phone,
            email: this.listQuery.email,
            remark: this.listQuery.remark
          }
          updateOne(data).then(response => {
            const { data } = response
            if (showPhoneAlarm(true, 'toast', null, 2000, data.code, '更新供应商', data.message)) {
              this.$router.push({ path:'/service/system/supplier', query: {} })
            }
            this.loading = false
          }).catch(function(error) {
            this.loading = false
            console.error(error)
          })
        }).catch(() => {
          showPhoneAlarm(true, 'toast', 'success', 2000, 200, '更新供应商', '取消')
        })
      },
      handleGetMaterialList() {
        const data = {
          page: 1,
          limit: 10000
        }
        getMaterialList(data).then(response => {
          const { data } = response
          if (showPhoneAlarm(false, 'toast', null, 2000, data.code, null, data.message)) {
            const items = data.data.items
            this.materialOptions = []
            const list = this.listQuery.material
            this.listQuery.material = []
            for (let i=0; i<items.length; i++) {
              this.materialOptions.push({
                id: items[i].id,
                name: items[i].name
              })
              if (list.indexOf(items[i].name) > -1) {
                this.listQuery.material.push(items[i].id)
              }
            }
          }
        }).catch(function(error) {
          console.error(error)
        })
      },
      validName(value) {
        return new Promise((resolve) => {
          const result = isChinese(value, 2, 20)
          if (result === true) {
            resolve(true)
          } else {
            showPhoneAlarm(true, 'toast', null, 2000, null, result, null)
            resolve(false)
          }
        })
      },
    }
  }
</script>

<style lang="less" scoped>
  // 系统样式修改
  ::v-deep .van-field__label {
    width: 5em;
  }
  ::v-deep .van-field__control:read-only {
    color: #999;
  }
  ::v-deep .van-checkbox {
    padding: 3px 0;
  }
  ::v-deep .van-checkbox__icon {
    font-size: 4.5vw;
  }
  // 自定义样式
  .main {
    height: 100vh;
    font-size: 2vw;
    background-color: #FFFFFF;//#F8F8F8; 
    overflow-x: hidden;
    // overflow-y:hidden;
    overflow-y: auto;
    // display: flex; 
    // justify-content: center; 
    // align-items: center;
  }
</style>
